<template>
  <div class="l_select" :value="$attrs.value" @click.capture="visible = true" :class="{ active: visible }">
    <el-form-item :label="label" :prop="name">
      <el-select
        v-on="listeners"
        v-bind="$attrs"
        class="showPlaceholder"
        :class="{ selected: listeners, creditCard: name === 'creditCard', ccReset: reset }"
        :disabled="disabled || reset"
        :data-testid="testId || name"
      >
        <el-option v-for="item in availableTypes" :key="item.id" :value="item.id">
          <div class="flex items-center justify-between">
            <img
              :class="limitImageSizeById.includes(item.id) ? 'type_Img50' : 'type_Img'"
              :src="withdrawalTypesMap[item.id].img"
              alt
            />

            <div class="select_text">
              {{ getTitleLabel(item.nameKey) }}
              <ProcessTime :time="getTimeOfWithdrawalType(item.id)" />
            </div>
          </div>
        </el-option>

        <template v-if="listeners" #prefix>
          <div
            v-if="chooseWithdrawalType"
            :class="{ small_style: ['pl'].includes(lang) }"
            class="select-container rtl:ml-[15px]"
          >
            <img
              :class="limitImageSizeById.includes(chooseWithdrawalType.id) ? 'type_Img50' : 'type_Img'"
              :src="withdrawalTypesMap[chooseWithdrawalType.id].img"
              alt
            />
            <div
              class="select_text"
              :class="{ small_text: [5, 6, 34, 36, 8, 24, 39, 40, 47].includes(chooseWithdrawalType.id) }"
            >
              <div class="leading-none">{{ getTitleLabel(chooseWithdrawalType.nameKey) }}</div>
              <ProcessTime :time="getTimeOfWithdrawalType(chooseWithdrawalType.id)" />
            </div>
            <div :class="{ mr_amount: ['zh_CN', 'zh_TW', 'ja', 'ko', 'vi'].includes(lang) }">
              {{ '$' + amount }}
            </div>
          </div>
          <div v-else-if="showCreditCard" class="select-container rtl:ml-[15px]">
            <img class="type_Img" src="@/assets/images/withdraw/master_card.png" alt />
            <div class="select_text">
              {{ $t('common.withdrawChannel.creditcard') }}
              <el-popover class="popover z-10" popper-class="pop_content" placement="bottom-end" trigger="hover">
                <svg-icon slot="reference" iconName="info-circle-icon" className="tooltip-icon" />
                <div class="remainingWithdraw" v-html="$t('withdraw.default.remainingWithdraw')"></div>
                <div v-html="$t('processTime.withdrawProcessTime', { time: $t('processTime.within1BDay') })"></div>
                <div v-html="$t('processTime.pspProcessTime', { time: $t('processTime.b37BDays') })"></div>
              </el-popover>
            </div>
            <div :class="{ mr_amount: ['zh_CN', 'zh_TW', 'ja', 'ko', 'vi'].includes(lang) }">
              {{ '$' + amount }}
            </div>
          </div>
          <div v-else class="select_text select-container rtl:mr-[30px] rtl:ml-[10px]">
            {{ selectText }}
          </div>
        </template>
      </el-select>
    </el-form-item>

    <el-dialog
      class="withdrawal_freeze_dialog"
      :title="$t('security.withdrawalFreeze.header')"
      :visible.sync="limitVisible"
      width="480px"
      center
      :show-close="true"
    >
      <div class="text-sm" v-if="fromFunctionCode === 'updateUserLogin'">
        {{ $t('security.withdrawalFreeze.userLoginDesc', { days: limitDayNumber, hours: lastHours }) }}
      </div>
      <div class="text-sm" v-if="fromFunctionCode === 'updatePassword'">
        {{ $t('security.withdrawalFreeze.passDesc', { days: limitDayNumber, hours: lastHours }) }}
      </div>
      <div class="text-sm" v-if="fromFunctionCode === 'changeAuthenticator'">
        {{ $t('security.withdrawalFreeze.limitSecurityAuthenticator', { days: limitDayNumber, hours: lastHours }) }}
      </div>
      <div class="text-center">
        <PrimaryButton
          padding="px-10"
          height="h-12"
          width="min-w-42"
          :onClick="closeLimitDialog"
          class="dialog-btn"
          bgColor="!bg-blueG1"
          >{{ $t('security.understand') }}
        </PrimaryButton>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ProcessTime from '@/components/ProcessTime.vue';
import selectWithdraw from '@/mixins/withdrawl/selectWithdraw';
import CpsWithdraw from '@/views/withdraw/CpsWithdraw.vue';
import vDialog from '@/components/vDialog.vue';
import PrimaryButton from '@/components/buttons/primaryButton/PrimaryButton.vue';
import { apiGetSecurity } from '@/resource';

export default {
  name: 'selectWithdraw',
  components: { ProcessTime, vDialog, PrimaryButton },
  mixins: [selectWithdraw],
  props: {
    name: String,
    label: String,
    testId: String,
    availableTypes: Array,
    amount: Number,
    disabled: Boolean,
    reset: Boolean,
    cpsPayments: Array,
    showCreditCard: {
      type: Boolean,
      default: false
    },
    selectText: String,
    paymentAuthConfig: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      withdrawalType: null,
      withdrawalNote: null,
      chooseWithdrawalType: null,
      currentComponent: null,
      limitImageSizeById: [35, 67, 42, 80, 81],
      limitVisible: false,
      fromFunctionCode: '',
      limitDayNumber: '',
      lastHours: '',
      limitTypes: [],
      withdrawLimitArrays: []
    };
  },
  computed: {
    listeners() {
      return Object.assign({}, this.$listeners, {
        input: event => {
          if (this.isLimitedTypes(event)) {
            this.limitVisible = true;
            return;
          }
          if (this.cpsPayments.includes(event)) {
            this.currentComponent = CpsWithdraw;
          } else {
            this.currentComponent = this.withdrawalTypesMap[event].component;
          }
          this.chooseWithdrawalType = this.availableTypes.find(f => f.id == event);
          this.withdrawalType = event;
          this.withdrawalNote = this.withdrawalTypesMap[event].note;
          this.emitWithdraw();
        }
      });
    },
    lang() {
      return this.$store.state.common.lang;
    }
  },
  mounted() {
    this.getSecuritys();
  },
  watch: {
    reset(val) {
      if (!val) {
        this.emitWithdraw();
      } else {
        this.currentComponent = null;
        this.chooseWithdrawalType = null;
        this.withdrawalType = null;
        this.clearWithdrawData();
      }
    },
    availableTypes(val) {
      if (!this.availableTypes.find(f => f.id == this.withdrawalType)) {
        this.currentComponent = null;
        this.chooseWithdrawalType = null;
        this.withdrawalType = null;
        this.emitWithdraw();
      }
    },
    disabled(val) {
      if (val) {
        this.currentComponent = null;
        this.chooseWithdrawalType = null;
        this.withdrawalType = null;
        this.emitWithdraw();
      }
    }
  },
  methods: {
    emitWithdraw() {
      this.$emit('setWithdraw', {
        currentComponent: this.currentComponent,
        chooseWithdrawalType: this.chooseWithdrawalType,
        withdrawalType: this.withdrawalType,
        withdrawalNote: this.withdrawalNote,
        amount: this.amount
      });
    },
    getTitleLabel(val) {
      if (this.$te(val) || this.$te(val, 'en_US')) {
        return this.$t(val);
      }
      return this.$options.filters.channelMethods(val);
    },
    clearWithdrawData() {
      this.$emit('setWithdraw', {
        currentComponent: null,
        chooseWithdrawalType: null,
        withdrawalType: null,
        withdrawalNote: null
      });
    },
    getTimeOfWithdrawalType(typeId) {
      return this.withdrawalTypesMap[typeId].time;
    },
    cancelChanges() {
      this.clearWithdrawData();
      this.withdrawalType = null;
      this.chooseWithdrawalType = null;
    },
    closeLimitDialog() {
      this.limitVisible = false;
    },
    isLimitedTypes(type) {
      // 找到按时间排序后并且包含该选中渠道的第一个限制
      const currLimitObj = this.withdrawLimitArrays.find(item => {
        let curr = item.limitWithdrawTypes ? item.limitWithdrawTypes.split(',').map(item => Number(item)) : [];
        return curr.includes(type);
      });

      // 如果找到限制
      if (currLimitObj && Object.keys(currLimitObj).length > 0) {
        this.fromFunctionCode = currLimitObj.fromFunctionCode;
        this.limitDayNumber = 'T + ' + currLimitObj.limitDayNumber;
        this.lastHours = currLimitObj.lastHours;
        this.limitTypes = currLimitObj.limitWithdrawTypes
          ? currLimitObj.limitWithdrawTypes.split(',').map(item => Number(item))
          : [];
        return true;
      } else {
        return false;
      }
    },
    async getSecuritys() {
      let _this = this;
      await apiGetSecurity().then(function (res) {
        if (res.data.code == 0 && res.data.data && res.data.data.length > 0) {
          let data = res.data.data;
          // 按时间排序
          _this.withdrawLimitArrays = data
            .filter(el => el.functionCode == 'withdraw')
            .sort((a, b) => b.limitTimeUTC - a.limitTimeUTC);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/withdraw/selectWithdraw.scss';
.withdrawal_freeze_dialog {
  /deep/ {
    .el-dialog__header {
      padding: 20px;
      text-align: center;
      color: #000a2d;
      .el-dialog__title {
        font-size: 20px;
        font-weight: 600;
      }
      .el-dialog__headerbtn {
        top: 26px;
        right: 20px;
        .el-dialog__close {
          font-size: 14px;
        }
      }
    }
  }
  /deep/.el-dialog {
    width: 480px;
    max-width: 497px;
    margin-top: 0vh !important;
    .el-dialog__body {
      text-align: center;
      word-break: normal;
      .text-sm {
        color: #606266;
        line-height: 1.5;
      }
      .text-center {
        margin-top: 20px;
      }
    }
  }
}
@media (max-width: 550px) {
  .withdrawal_freeze_dialog {
    /deep/.el-dialog {
      width: 300px !important;
    }
    /deep/ .el-dialog .el-dialog__body {
      font-size: 14px;
    }
  }
}
</style>
